module.exports = __webpack_public_path__ + "img/n.b3c6d852.jpg";